import { ROUTES } from "@/shared";

import TableHeadActions from "../../../actions/TableHeadActions/TableHeadActions";
import TableHeadToolbar from "../../TableHeadToolbar/TableHeadToolbar";

interface IMobileTableHeadActiveProps {
  route: ROUTES;
  setIsTableheadActive: (isActive: boolean) => void;
}

const MobileTableHeadActive = ({
  route,
  setIsTableheadActive
}: IMobileTableHeadActiveProps) => {
  const toggleActiveHead = (value: boolean) => setIsTableheadActive(value);

  return (
    <TableHeadToolbar route={route}>
      <TableHeadActions toggleActiveHead={toggleActiveHead} route={route} />
    </TableHeadToolbar>
  );
};

export default MobileTableHeadActive;
